import React, { Component } from 'react';
// import PropTypes from "prop-types";
import {
  Card,
  Button,
  CardHeader,
  // CardFooter,
  CardBody,
  // CardTitle,
  // CardText
} from 'reactstrap';

const Offer = props => {
  return (
    <Card className="box-shadow" style={{ margin: '15px', flex: 1 }}>
      <CardHeader>
        <h4 className="font-weight-normal">Free</h4>
      </CardHeader>
      <CardBody>
        <h1>
          $0 <small className="text-muted"> / mo</small>
        </h1>
        <ul className="list-unstyled mt-3 mb-4">
          <li>10 users included</li>
          <li>2 GB of storage</li>
          <li>Email support</li>
          <li>Help center access</li>
        </ul>
        <Button color="primary">Sign up for free</Button>
      </CardBody>
    </Card>
  );
};

export class PricingPage extends Component {
  render() {
    return (
      <div className="mt-5 text-center">
        <h1 className="">Pricing</h1>
        <div
          className="col-md-8 offset-md-2"
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}
        >
          <Offer />
          <Offer />
          <Offer />
        </div>
      </div>
    );
  }
}

// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
PricingPage.propTypes = {};
export default PricingPage;



// WEBPACK FOOTER //
// ./src/pages/PricingPage.js